import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { InstitutesComp } from './institutes';
import { GetLeadsFromStorage, GetProcessList } from '../../models/process';
import { pnkstore } from '../../stores/pnk-store';
import { useUserStore } from '../../stores/user-store';
import { useNavigate } from 'react-router-dom';
import { GetAllLeads, AddInteraction, MakeCall, GetAllInstitutes, AddInteractionForInstitute, GetInstituteTimeline } from '../../models/leads';
import { Filters } from '../Filters';
import { GetUserList } from '../../models/user';

export const Institutes = () => {
    const userData = useUserStore;
    const [openFilter, setOpenFilter] = useState(false);
    const [getLeadList, setGetLeadList] = useState(false);
    const [instituteList, setInstituteList] = useState([]);

    const [leadObj, setLeadObj] = useState({});
    const [setNo, setSetNo] = useState(1);
    const [perSet, setPerSet] = useState(50);
    const [totalRecords, setTotalRecords] = useState(0);

    const [interactionData, setInteractionData] = useState({});

    const [callObj, setCallObj] = useState({});
    const [makeCall, setMakeCall] = useState(false);

    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertMsg, setAlertMsg] = useState('');

    const [openInteractionBox, setOpenInteractionBox] = useState(false);

    const [statusListArray, setstatusListArray] = useState([]);
    const [getUserList, setGetUserList] = useState(false);
    const [userListData, setUserListData] = useState([]);

    const [addInteraction, setAddInteraction] = useState(false);

    const [getTimeline, setGetTimeline] = useState(false);
    const [timelineObj, setTimelineObj] = useState({});

    const [timelinePopup, setTimelinePopup] =
        useState(false);

    const [timelineData, setTimelineData] =
        useState([]);

    const navigate = useNavigate();


    const state = {
        userData: userData.getState(),
        getLeadList: getLeadList,
        instituteList: instituteList,
        totalRecords: totalRecords,
        perSet: perSet,
        setNo: setNo,
        leadObj: leadObj,
        showAlert: showAlert,
        alertMsg: alertMsg,
        alertType: alertType,
        openInteractionBox: openInteractionBox,
        statusListArray: statusListArray,
        userListData: userListData
    }



    useEffect(() => {
        let statusListArray = ['Pending', 'RNR', 'Hold', 'Call Back', 'Dead', 'In Progress'];
        setstatusListArray(statusListArray);
        setLeadObj({
            'set_no': setNo,
            'per_set': perSet,
            'ddlCandidateStatus': userData.getState().profile === 'Admin' || userData.getState().profile === 'Marketing' ? 'Not Shortlisted' : userData.getState().profile.includes('Sales') ? 'Shortlisted' : ''
        })
        setGetLeadList(true);
    }, []);

    const HandleChangePage = (event, page) => {
        let set_no = setNo;
        if (event.currentTarget.title == 'Go to next page') {
            set_no = set_no + 1;
        }
        else {
            set_no = set_no - 1;
        }
        setSetNo(set_no);
        setLeadObj((prev) => ({ ...prev, ['set_no']: set_no }));
        setGetLeadList(true);
    };

    const HandleCloseAlertMsg = (type) => {
        setTimeout(() => {
            setShowAlert(false);
            setAlertType('');
            setAlertMsg('');
        }, 2000)

    }

    const HandleChangeRowsPerPage = (event) => {
        let value = event.target.value;
        console.log(event.target.value);
        setPerSet(value);
        setSetNo(1);
        setLeadObj((prev) => ({ ...prev, ['set_no']: 1 }));
        setLeadObj((prev) => ({ ...prev, ['per_set']: value }));
        setGetLeadList(true);

    };

    const ResetPagination = () => {
        setSetNo(1);
        setPerSet(50);
        setLeadObj((prev) => ({ ...prev, ['set_no']: 1 }));
        setLeadObj((prev) => ({ ...prev, ['per_set']: 50 }));
    }

    const NavigateTo = (route) => {
        navigate('/' + route, { state: {} });
    }

    const HandleInputs = (e, name) => {
        let value = '';

        if (name === 'txtCallBackDateTime') {
            value = e.$d;
            value = new Date(new Date(value).getTime() - (new Date(value).getTimezoneOffset() * 60000)).toISOString().substr(0, 19).replace('T', ' ')
        }
        else {
            value = e.target.value
        }

        if (name === 'txtInstituteSearchName') {
            setLeadObj((prev) => ({ ...prev, ['txtInstituteSearchName']: value }));
        }
        if (name === 'ddlCandidateStatus') {
            setLeadObj((prev) => ({ ...prev, ['ddlCandidateStatus']: value }));
            setGetLeadList(true);
        }
        if (name === 'ddlLeadStatus') {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadStatus']: value }));
        }
        if (name === 'txtInteractionDesc') {
            setInteractionData((prev) => ({ ...prev, ['txtInteractionDesc']: value }));
        }
        if (name === 'txtCallBackDateTime') {
            setInteractionData((prev) => ({ ...prev, ['txtCallBackDateTime']: value }));
        }
        if (name === 'txtDeadReason') {
            setInteractionData((prev) => ({ ...prev, ['txtDeadReason']: value }));
        }
        if (name === 'ddlLeadDepartment') {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadDepartment']: value }));
            setGetUserList(true);
        }
        if (name === 'ddlLeadOwner') {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadOwner']: value }));
        }
    }

    const HandleGetUsersListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res);
            let usersListData = res.data.userlistresponse.rows
            setUserListData(usersListData);
        }
        else {
            setUserListData([]);
        }
        setGetUserList(false);
    }

    const HandleGetLeadListSuccessResponse = (res) => {
        if (res != false && res != 'error') {
            console.log(res.data.leadlistresponse.rows[0])
            setInstituteList(res.data.leadlistresponse.rows)
            setTotalRecords(res.data.leadlistresponse.metarow.totalRecordsInDb);
        }
        else {
            setInstituteList([]);
            setTotalRecords(0);
        }
        setGetLeadList(false);
    }


    const ToggleFilter = () => {
        //  alert(openFilter);
        // userData.setState({ openFilter: true });
        if (openFilter === true) {
            setOpenFilter(false);
        }
        else {
            setOpenFilter(true);
        }
    }


    const SearchLeadList = (type, searchData) => {
        console.log(searchData);
        if (type === 'reload') {
            setLeadObj({
                'set_no': setNo,
                'per_set': perSet,
                'txtInstituteSearchName': '',
            })
        }
        else if (type === 'direct') {
            setLeadObj({
                'set_no': setNo,
                'per_set': perSet,
                'txtInstituteSearchName': leadObj.txtInstituteSearchName,
            })
        }
        else {
            // alert('I am here');
            setLeadObj({
                'set_no': setNo,
                'per_set': perSet,
                'txtLeadSearchStartDate': searchData.txtLeadSearchStartDate,
                'txtLeadSearchEndDate': searchData.txtLeadSearchEndDate,
                'ddlLeadSearchState': searchData.ddlLeadSearchState,
                'ddlLeadSearchDistrict': searchData.ddlLeadSearchDistrict,
                'ddlLeadSearchDepartment': searchData.ddlLeadSearchDepartment,
                'ddlLeadSearchOwner': searchData.ddlLeadSearchOwner,
                'ddlLeadSearchProject': searchData.ddlLeadSearchProject,
                'ddlLeadSearchStatus': searchData.ddlLeadSearchStatus,
                'txtSearchCity': searchData.txtSearchCity
            })

            ToggleFilter();
        }
        ResetPagination();
        setGetLeadList(true);

    }

    const ToggleInteractionBox = () => {
        if (openInteractionBox == true) {
            setOpenInteractionBox(false);
        }
        else {
            setOpenInteractionBox(true);
        }
    }

    const MakeNewCall = (leadData) => {
        // console.log(leadData);
        setCallObj({
            'txtUserNumber': leadData.institute_uprn_poc_mobile,
            'txtCallerNumber': userData.getState().mobile,
            'txtUserName': leadData.institute_uprn_poc_name,
            'txtUserEmail': leadData.institute_uprn_poc_email,
            'txtInstituteId': leadData._id,
            'txtLeadOwner': leadData.lead_owner_name,
            'txtLeadStatus': leadData.lead_stage,
            'txtLeadSource': leadData.lead_source,
            'type': 'Institute'
        });


        console.log(callObj);

        setMakeCall(true);
        // call exotel api to make call


        //  HandleMakeCallResponse(true);
    }

    const HandleMakeCallResponse = (res) => {
        setMakeCall(false);

        if (res !== false) {
            setShowAlert(true);
            setAlertType('success')
            setAlertMsg(res.data.exotelcallresponse.message.value);
            // now open interaction popup after 3 sec
            setTimeout(() => {
                ToggleInteractionBox();
            }, 3000)

        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Call Failed');
        }

    }


    const AddNewInteraction = () => {
        if (interactionData.ddlLeadStatus == undefined || interactionData.ddlLeadStatus == null || interactionData.ddlLeadStatus.trim() == '') {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadStatusErr']: 'Please Select Status' }));
            return false;
        }
        else {
            setInteractionData((prev) => ({ ...prev, ['ddlLeadStatusErr']: '' }));
        }
        if (interactionData.ddlLeadStatus === 'Call Back') {
            if (interactionData.txtCallBackDateTime == undefined || interactionData.txtCallBackDateTime == null || interactionData.txtCallBackDateTime.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['txtCallBackDateTimeErr']: 'Please Select Call Back Datetime' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['txtCallBackDateTimeErr']: '' }));
            }
        }
        if (interactionData.ddlLeadStatus === 'Onboarding') {
            if (interactionData.txtOnboardingDateTime == undefined || interactionData.txtOnboardingDateTime == null || interactionData.txtOnboardingDateTime.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['txtOnboardingDateTimeErr']: 'Please Select Call Back Datetime' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['txtOnboardingDateTimeErr']: '' }));
            }
        }
        if (interactionData.ddlLeadStatus === 'Dead') {
            if (interactionData.txtDeadReason == undefined || interactionData.txtDeadReason == null || interactionData.txtDeadReason.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['txtDeadReasonErr']: 'Please Enter Dead Reason' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['txtDeadReasonErr']: '' }));
            }
        }
        if (interactionData.ddlLeadStatus === 'In Progress') {
            if (interactionData.ddlLeadDepartment == undefined || interactionData.ddlLeadDepartment == null || interactionData.ddlLeadDepartment.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['ddlLeadDepartmentErr']: 'Please Select Department' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['ddlLeadDepartmentErr']: '' }));
            }
            if (interactionData.ddlLeadOwner == undefined || interactionData.ddlLeadOwner == null || interactionData.ddlLeadOwner.trim() == '') {
                setInteractionData((prev) => ({ ...prev, ['ddlLeadOwnerErr']: 'Please Select Owner' }));
                return false;
            }
            else {
                setInteractionData((prev) => ({ ...prev, ['ddlLeadOwnerErr']: '' }));
            }
        }
        setInteractionData((prev) => ({ ...prev, ['txtInstituteId']: callObj.txtInstituteId }));
        console.log(interactionData);
        // console.log(callObj);
        // call interaction api

        setAddInteraction(true);
    }




    const HandleInteractionSuccessResponse = (res) => {
        console.log(res);

        if (res !== false) {
            setShowAlert(true);
            setAlertType('success')
            setAlertMsg(res.data.interactionresponse.message.value);
        }
        else {
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('Interaction Not Added');
        }
        setInteractionData({});
        ToggleInteractionBox();
        setGetLeadList(true);
        setAddInteraction(false);
    }

    const GetTimelineData = (institute_id) => {
        setTimelineObj({
            'instituteId': institute_id
        });
        setGetTimeline(true);
    }

    const HandleInstituteTimelineSuccessResponse = (res) => {
        setGetTimeline(false);
        if (res !== false) {
            console.log(res);
            let timelineData = res.data.timelineresponse.message.value;
            if (timelineData && timelineData.length > 0) {
                setTimelineData(
                    res.data.timelineresponse.message.value
                );
                setTimelinePopup(true);
            }
            else {
                setTimelineData(
                    []
                );
                setShowAlert(true);
                setAlertType('error')
                setAlertMsg('No Data Found');
            }

        }
        else {
            setTimelineData(
                []
            );
            setShowAlert(true);
            setAlertType('error')
            setAlertMsg('No Data Found');
            // setTimelinePopup(true);
        }

    }

    const CloseTimeLine = () => {
        setTimelinePopup(false);
    }






    return (
        <Box>
            {
                openFilter === true ?

                    <Filters ToggleFilter={ToggleFilter} type={'Institute'} candidateStatus={leadObj.ddlCandidateStatus} SearchList={SearchLeadList} />

                    :
                    null
            }
            <InstitutesComp
                HandleChangePage={HandleChangePage} HandleChangeRowsPerPage={HandleChangeRowsPerPage}
                mystate={state}
                NavigateTo={NavigateTo}
                HandleInputs={HandleInputs}
                ToggleFilter={ToggleFilter}
                SearchLeadList={SearchLeadList}
                MakeNewCall={MakeNewCall}
                HandleCloseAlertMsg={HandleCloseAlertMsg}
                interactionData={interactionData}
                ToggleInteractionBox={ToggleInteractionBox}
                AddNewInteraction={AddNewInteraction}
                GetTimelineData={GetTimelineData}
                timelinePopup={timelinePopup}
                timelineData={timelineData}
                CloseTimeLine={CloseTimeLine}

            />
            {((getLeadList === true) ? GetAllInstitutes(pnkstore, leadObj, userData.getState().token, HandleGetLeadListSuccessResponse) : "")}
            {((getUserList === true) ? GetUserList(pnkstore, {}, userData.getState().token, HandleGetUsersListSuccessResponse) : "")}
            {((makeCall === true) ? MakeCall(pnkstore, callObj, userData.getState().token, HandleMakeCallResponse) : "")}
            {((addInteraction === true) ? AddInteractionForInstitute(pnkstore, interactionData, userData.getState().token, HandleInteractionSuccessResponse) : "")}
            {((getTimeline === true) ? GetInstituteTimeline(pnkstore, timelineObj, userData.getState().token, HandleInstituteTimelineSuccessResponse) : "")}
        </Box>
    )
}